import React, { useContext } from "react";

export default function Modal(){
    return <section className={`flex alignCenter container modalSection`}>
        <svg stroke="currentColor" fill="none" strokeWidth="2" viewBox="0 0 24 24" strokeLinecap="round" strokeLinejoin="round" height="22" width="22" xmlns="http://www.w3.org/2000/svg"><circle cx="12" cy="12" r="10"></circle><line x1="12" y1="16" x2="12" y2="12"></line><line x1="12" y1="8" x2="12.01" y2="8"></line></svg>
        <p className="faFont textSize1 textClr5 modalText">متن نمایشی</p>
    </section>
}